export default {"src":"/_next/static/media/6.cf117d14.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};